<template>

    <div class="p-5 lg:p-20 flex flex-col space-y-6 bg-button-teal">
        <div class="bg-icon-light p-4 rounded-md max-w-7xl w-full mx-auto flex flex-col">
          <editable-headline field="offer" default="Offer" :width="true" class="pl-4"/>
            <div class="grid grid-cols-2 text-sm">
                <div class="m-4 space-y-4">
                    <div class="bg-white rounded-md flex justify-between px-5 py-3 font-semibold">
                        <span>Total</span>
                        <span>{{ store.proposal.amount_pr_pax }},- per person</span>
                    </div>
                    <div class="bg-white rounded-md px-5 py-3 space-y-5">
                        <span class="font-semibold">Price includes</span>
                      <div class="mr-6">
                        <editable-bullet-list v-model="form.data.price_bullets" />
                      </div>
                    </div>
                  <div class="flex justify-between font-semibold">
                    <span>Optional additions</span>
                    <span @click="showModal = true" class="cursor-pointer text-indigo-600">edit</span>
                  </div>
                    <div v-for="option in store.proposal.data.optional_additions" class="bg-white rounded-md flex justify-between px-5 py-3 font-semibold">
                        <span>{{ option.text }}</span>
                        <span>{{ option.amount }},- {{ option.priceOption }}</span>
                    </div>
                </div>
                <div class="m-4">
                    <div class="bg-white rounded-md flex flex-col space-y-5 px-5 py-3">
                      <p class="font-semibold">
                          Summary
                      </p>

                      <div class="sm:w-1/2 space-y-1">
                        <div class="sm:grid sm:grid-cols-3 sm:gap-4">
                          <dt class="">Travelers</dt>
                          <dd class="mt-1 sm:col-span-2 sm:mt-0 font-semibold sm:text-right">{{ store.proposal.pax }}</dd>
                        </div>
                        <div class="sm:grid sm:grid-cols-3 sm:gap-4">
                          <dt class="">Nights</dt>
                          <dd class="mt-1 sm:col-span-2 sm:mt-0 font-semibold sm:text-right">{{ Object.keys(store.days).length - 1 }}</dd>
                        </div>
                      </div>

                      <div class="mr-6">
                        <editable-text-area v-model="form.data.summary" />
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white rounded-md grid grid-cols-2 divide-x text-sm text-gray-700 items-center mx-auto max-w-7xl w-full">
            <div class="p-8 flex space-x-5 items-center">
                <img class="h-32 w-32 rounded-full object-cover " :src="store.proposal.creator.profile_photo_url" alt="">
                <div class="flex flex-col space-y-3">
                    <p>Your sincerely,</p>
                    <p class="flex flex-col">
                        <span class="font-semibold">{{ store.proposal.creator.name }}</span>
                        <a :href="'mailto:' + store.proposal.creator.email" class="underline hover:text-gray-900">{{ store.proposal.creator.email }}</a>
                    </p>
                </div>
            </div>
            <div class="p-5 h-32 flex flex-col justify-end">
                <!-- <p>Organization no.: XXX XXX XXX</p> -->
                <p>Delivered to you by: {{ store.proposal.project.team.name }}</p>
            </div>
        </div>
    </div>
  <optional-additions-modal :show="showModal" @close="showModal = false" @save="updateOptionalAdditions"/>
</template>

<script setup>
import {useProposalOldStore} from "@/Stores/ProposalOld";
import EditableTextArea from "@/ComponentsDeprecated/Proposal/EditableTextArea";
import EditableBulletList from "@/ComponentsDeprecated/Proposal/EditableBulletList";
import {ref} from "vue";
import OptionalAdditionsModal from "@/ComponentsDeprecated/Modal/Proposal/OptionalAdditionsModal";
import EditableHeadline from "@/ComponentsDeprecated/Proposal/EditableHeadline";
const store = useProposalOldStore();
const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
});

const showModal = ref(false);

function updateOptionalAdditions(data) {
  props.form.data.optional_additions = JSON.parse(JSON.stringify(data));
  showModal.value = false;
}
</script>
